import React, { useState, useEffect } from "react";
import axios from "axios";
import { BiSolidConversation } from "react-icons/bi";
import {
  FaUserAlt,
  FaMinusCircle,
  FaPlusCircle,
  FaEdit,
  FaSave,
} from "react-icons/fa";
import { MdOutlineSupportAgent } from "react-icons/md";
import "./user-chat.css";
import { toast } from "react-toastify";

const ChatDetails = ({
  chat,
  conversationHistory,
  onDateSelect,
  isSidepanelOpen,
  toggleSidePanel,
  setIsAgentToAgent,
  IsAgentToAgent,
}) => {
  const ApiBaseURL = process.env.REACT_APP_GROUP_URL;
  const token = localStorage.getItem("authToken");
  const isAgent = localStorage.getItem("isAgent") === "true";
  const [openAccordion, setOpenAccordion] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [customerDetails, setCustomerDetails] = useState({
    name: "",
    mobile: "",
    email: "",
    address: "",
  });
  const [selectedAgent, setSelectedAgent] = useState("");
  const [agents, setAgents] = useState([]);
  const [error, setError] = useState(null);
  const [isOpen, setIsOpen] = useState(isSidepanelOpen);
  const handleSidebar = () => setIsOpen(!isOpen);
  useEffect(() => {
    if (isOpen !== isSidepanelOpen) {
      handleSidebar();
    }
  }, [isSidepanelOpen]);

  const toggleAccordion = (accordion) => {
    setOpenAccordion(openAccordion === accordion ? null : accordion);
  };

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleSave = () => {
    setIsEditing(false);
    // Save customer details here
  };

  const handleChange = (e) => {
    setCustomerDetails({
      ...customerDetails,
      [e.target.name]: e.target.value,
    });
  };

  // Function to handle connect button click
  const handleConnect = async () => {
    if (!selectedAgent) {
      toast.error("Please select an agent to connect.");
      return;
    }

    if (chat.AgentName) {
      const confirmTransfer = window.confirm(
        `This chat is already assigned to ${chat.AgentName}. Do you want to transfer it to another agent?`
      );

      if (!confirmTransfer) {
        return;
      }
    }

    try {
      const response = await axios.get(
        `${ApiBaseURL}WhatsappGroup/ShareUserchatToAgent?AgentId=${selectedAgent}&customerNumber=${chat.number}&LastMessage=Trasfer&isAgent=${isAgent}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        toast.success("Chat successfully transferred to the agent.");
      } else {
        toast.error(
          `Failed to transfer chat to the agent. Status: ${response.status}`
        );
      }
    } catch (err) {
      toast.error("Failed to connect to the agent. Please try again later.");
    }
  };

  return (
    <div
      className={`fixed top-15 right-0 transform transition-transform user-settings flex justify-center items-start bg-gray-100 p-2 duration-500 ${isOpen ? "translate-x-0" : "translate-x-full"
        }`}
    >
      <div className="w-full sm:w-80 md:w-96 bg-white shadow-lg p-4 max-h-[60vh] relative">
        <button
          className={`absolute top-3/4 -left-10 ${isSidepanelOpen ? "" : "hidden"
            } md:block transform -translate-y-1/2 rotate-90 bg-[#2c678d] text-white px-4 py-2 rounded z-20 transition-transform -translate-x-11 text-sm`}
          onClick={() => toggleSidePanel()}
        >
          Group Settings
        </button>
        {!IsAgentToAgent && (
          <button
            className="w-full flex items-center justify-between mb-2 p-2 border rounded bg-white"
            onClick={() => toggleAccordion(1)}
          >
            <div className="flex items-center mt-1 pt-1 mb-1 pb-1">
              <FaUserAlt size={20} className="mr-2" />
              <h3 className="text-md font-medium">Group Details</h3>
            </div>
            {openAccordion === 1 ? (
              <FaMinusCircle size={20} className="text-black-500" />
            ) : (
              <FaPlusCircle size={20} className="text-black-500" />
            )}
          </button>
        )}

        {openAccordion === 1 && (
          <div className="ml-2">
            {isEditing ? (
              <div>
                <input
                  type="text"
                  name="name"
                  value={customerDetails.name}
                  onChange={handleChange}
                  className="w-full mb-2 p-2 border rounded"
                />
                <input
                  type="text"
                  name="mobile"
                  value={customerDetails.mobile}
                  onChange={handleChange}
                  className="w-full mb-2 p-2 border rounded"
                />
                <input
                  type="email"
                  name="email"
                  value={customerDetails.email}
                  onChange={handleChange}
                  className="w-full mb-2 p-2 border rounded"
                />
                <input
                  type="text"
                  name="address"
                  value={customerDetails.address}
                  onChange={handleChange}
                  className="w-full mb-2 p-2 border rounded"
                />
                <button
                  className="w-full flex items-center justify-center p-2 border rounded bg-[#2c678d] text-white"
                  onClick={handleSave}
                >
                  <FaSave size={20} className="mr-2" />
                  Save
                </button>
              </div>
            ) : (
              <div>
                <p className="my-2">Name: {chat.groupName}</p>
              </div>
            )}
          </div>
        )}

        <button
          className="w-full flex items-center justify-between mt-2 pt-2 mb-2 p-2 border rounded bg-white"
          onClick={() => toggleAccordion(2)}
        >
          <div className="flex items-center">
            <BiSolidConversation size={20} className="mr-2" />
            <h3 className="text-sm font-medium">Conversation History</h3>
          </div>
          {openAccordion === 2 ? (
            <FaMinusCircle size={20} className="text-black-500" />
          ) : (
            <FaPlusCircle size={20} className="text-black-500" />
          )}
        </button>
        {openAccordion === 2 && (
          <div className="ml-2 max-h-52 overflow-y-auto border border-gray-300 p-2">
            {conversationHistory.map((history, index) => (
              <div
                key={index}
                className="mb-2 cursor-pointer hover:bg-gray-200 p-2 transition"
                onClick={() => onDateSelect(history.date)}
              >
                <p className="text-sm">{history.date}</p>
              </div>
            ))}
          </div>
        )}

        {openAccordion === 3 && (
          <div className="ml-2">
            <select
              value={selectedAgent}
              onChange={(e) => setSelectedAgent(e.target.value)}
              className="w-full mb-2 p-2 border rounded text-sm"
            >
              <option value="" disabled>
                Select an Agent
              </option>
              {agents.map((agent, index) => (
                <option key={index} value={agent.id}>
                  {agent.name}
                </option>
              ))}
            </select>
            <button
              className="w-full flex items-center justify-center p-2 border rounded bg-[#2c678d] text-white"
              onClick={handleConnect}
            >
              <MdOutlineSupportAgent size={20} className="mr-2" />
              Transfer
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatDetails;
